/**
 * Sencify Email-Protection
 * Ersetzt <span class="sencify-mail" data-u="..." data-d="..."> durch echten mailto-Link.
 * Ziel: Frontend-E-Mails nicht im Klartext-HTML fuer Spam-Bots, aber fuer Google (JS) + Nutzer sichtbar.
 * Impressumspflicht erfuellt via <noscript>-Fallback.
 */
(function () {
  function decode() {
    var els = document.querySelectorAll('.sencify-mail');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var u = el.getAttribute('data-u');
      var d = el.getAttribute('data-d');
      if (!u || !d) continue;
      var addr = u + '@' + d;
      var label = el.getAttribute('data-label') || addr;
      var a = document.createElement('a');
      a.href = 'mailto:' + addr;
      a.textContent = label;
      a.setAttribute('rel', 'nofollow');
      el.innerHTML = '';
      el.appendChild(a);
      el.classList.add('sencify-mail--decoded');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decode);
  } else {
    decode();
  }
})();
